import "core-js/modules/es.array.reduce.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import "core-js/modules/es.array.reduce.js";
import Analytics from 'analytics';
import googleAnalytics from '@analytics/google-analytics';
import googleTagManager from '@analytics/google-tag-manager';
import originalSrc, { getOriginalSource, getOriginalLandingPage } from 'analytics-plugin-original-source';
import uuidv4 from 'uuid/v4';
import { logger } from '../logger';
var TRACKING_ID;
var TAG_ID;
var UTM_SOURCE;
var UTM_SOURCE_CACHE_KEY = 'UTM_SOURCE_CACHE_KEY';
var setWithExpiry = function setWithExpiry(key, value, ttl) {
  var now = new Date();
  var item = {
    value: value,
    expiry: now.getTime() + ttl
  };
  localStorage.setItem(key, JSON.stringify(item));
};
var getWithExpiry = function getWithExpiry(key) {
  var itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  var item = JSON.parse(itemStr);
  var now = new Date();
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
};
export var eventTypes = {
  CLICK: 'UserClick',
  INPUT_CHANGE: 'InputChange',
  REGISTRATION: 'Registration',
  CONVERSION: 'Conversion',
  SOURCES: 'Sources',
  SESSION: 'Session'
};
var actionTypes = {
  USER_NO_REGISTRATION: 'USER-NO-REGISTRATION',
  NEW_REGISTRATION_COMPLETED: 'NEW-REGISTRATION-COMPLETED',
  LOG_IN: 'LOG_IN',
  LOG_OUT: 'LOG_OUT'
};
var analyticSingleton;
var sessionId = uuidv4();
var userData = {
  email: "NOT_REGISTERED@temporary-sendfx.com.au"
};
var userLogged;
var order = 1;
var gaData = {};
var isUnregistered;
var isRegistered;
var isLoggerEnabled;
var resolveClientIdPromise;
var loadClientIdPromise = new Promise(function (resolve) {
  resolveClientIdPromise = resolve;
});
var getClientId = function getClientId() {
  return loadClientIdPromise;
};
export var getUtmSource = function getUtmSource() {
  if (UTM_SOURCE) {
    return UTM_SOURCE;
  }
  var cachedUtm = getWithExpiry(UTM_SOURCE_CACHE_KEY);
  if (cachedUtm) {
    return cachedUtm;
  }
  var urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('utm_source');
};
var getGoogleAnalyticsDedicatedQueryParameters = function getGoogleAnalyticsDedicatedQueryParameters() {
  var urlParams = new URLSearchParams(window.location.search);
  var ca = urlParams.get('CA');
  var clientId = urlParams.get('cid');
  var utmSource = urlParams.get('utm_source');
  return {
    ca: ca,
    clientId: clientId,
    utmSource: utmSource
  };
};
var buildString = function buildString(object, separator) {
  if (object === void 0) {
    object = {};
  }
  if (separator === void 0) {
    separator = ';';
  }
  return Object.entries(object).reduce(function (acc, _ref) {
    var prop = _ref[0],
      value = _ref[1];
    if (value) {
      acc.push(prop + ":" + value);
    }
    return acc;
  }, []).join(separator);
};
export var initializeAnalytics = function initializeAnalytics(_ref2) {
  var credentials = _ref2.credentials,
    credentialKey = _ref2.credentialKey,
    project = _ref2.project,
    enableLogger = _ref2.enableLogger;
  if (!credentials) {
    throw Error('credentials are mandatory');
  }
  if (!analyticSingleton) {
    TRACKING_ID = credentials.analytics[credentialKey] && credentials.analytics[credentialKey].uid;
    TAG_ID = credentials.tag[credentialKey] && credentials.tag[credentialKey] && credentials.tag[credentialKey][project].uid;
    var plugins = [!!TRACKING_ID && googleAnalytics({
      // enforce NO DEBUGGING
      debug: false,
      trackingId: TRACKING_ID
    }), !!TAG_ID && googleTagManager({
      containerId: TAG_ID
    }), originalSrc()].filter(Boolean);
    var analytic = Analytics({
      app: 'portal',
      plugins: plugins
    });
    analyticSingleton = analytic;
    isLoggerEnabled = enableLogger;
    analyticSingleton.page();
    var _getGoogleAnalyticsDe = getGoogleAnalyticsDedicatedQueryParameters(),
      originalClientId = _getGoogleAnalyticsDe.clientId,
      ca = _getGoogleAnalyticsDe.ca,
      utmSource = _getGoogleAnalyticsDe.utmSource;
    UTM_SOURCE = utmSource;
    if (UTM_SOURCE) {
      setWithExpiry(UTM_SOURCE_CACHE_KEY, UTM_SOURCE, 60 * 60 * 1000); // 60 minutes
    }

    if (!UTM_SOURCE) {
      UTM_SOURCE = getWithExpiry(UTM_SOURCE_CACHE_KEY);
    }
    analytic.on('ready', function () {
      window.ga(function (tracker) {
        var clientId = tracker.get('clientId');
        gaData.clientId = originalClientId || clientId;
        gaData.CA = ca;
        userData = Object.assign({}, userData);
        resolveClientIdPromise(gaData.clientId);
      });
    });
  }
};
export var setLogger = function setLogger() {
  isLoggerEnabled = true;
};

// this is so we can enable logger in any env and track any issue.
if (typeof window !== 'undefined') {
  window.analytics = {
    setLogger: setLogger
  };
}
var log = function log(type, data) {
  if (isLoggerEnabled) {
    logger.log("ANALYTICS - " + type, data);
  }
};
var sendIdentify = function sendIdentify(email, data) {
  if (analyticSingleton) {
    analyticSingleton.identify(email, data);
  }
  log(email, data);
};
var sendEvent = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(type, data) {
    var clientId, thisData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getClientId();
          case 2:
            clientId = _context.sent;
            thisData = Object.assign({}, data, {
              label: (data.label || '') + ";clientId:" + clientId + ";CA:" + gaData.CA,
              value: order
            });
            if (analyticSingleton) {
              analyticSingleton.track(type, thisData);
            }
            // this is so we can sort in GA
            order += 1;
            log(type, thisData);
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function sendEvent(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
var unregisteredUser = function unregisteredUser() {
  if (!isUnregistered) {
    sendEvent(actionTypes.USER_NO_REGISTRATION, {
      category: eventTypes.REGISTRATION,
      label: buildString({
        temporaryEmail: userData.email,
        sessionId: sessionId
      })
    });
    isUnregistered = true;
    sendIdentify(userData.email, userData);
  }
};
var sessionStarted = function sessionStarted() {
  if (!userLogged) {
    userLogged = true;
    sendEvent(actionTypes.LOG_IN, {
      category: eventTypes.SESSION,
      label: buildString({
        email: userData.email,
        sessionId: sessionId
      })
    });
  }
};
var sessionFinish = function sessionFinish() {
  sendEvent(actionTypes.LOG_OUT, {
    category: eventTypes.SESSION,
    label: buildString({
      email: userData.email,
      sessionId: sessionId
    })
  });
  // create a new session for the next log in
  userLogged = false;
  sessionId = uuidv4();
  order = 1;
  userData = {
    email: "NOT_REGISTERED@temporary-sendfx.com.au"
  };
  isUnregistered = undefined;
  isRegistered = undefined;
};
var getSource = function getSource() {
  var original = getOriginalSource();
  var landing = getOriginalLandingPage();
  return Object.assign({}, original, {
    landing: landing
  });
};
var registeredUser = function registeredUser(_ref4) {
  var firstName = _ref4.firstName,
    lastName = _ref4.lastName,
    email = _ref4.email;
  if (!email) {
    throw Error('email is required');
  }
  if (!isRegistered) {
    isRegistered = true;
    var unregisteredInfo = Object.assign({}, userData);
    userData = {
      firstName: firstName,
      lastName: lastName,
      email: email
    };
    if (isUnregistered) {
      sendEvent(actionTypes.NEW_REGISTRATION_COMPLETED, {
        category: eventTypes.REGISTRATION,
        label: buildString({
          email: userData.email,
          sessionId: sessionId
        })
      });
      userData = Object.assign({}, userData, {
        newUser: true,
        oldUserInfo: unregisteredInfo
      });
    }
    sessionStarted();
    sendEvent(actionTypes.LOG_IN, {
      category: eventTypes.SOURCES,
      label: buildString(Object.assign({}, getSource(), {
        email: email,
        sessionId: sessionId
      }))
    });
    sendIdentify(email, userData);
  }
};
var event = function event(actionType, args) {
  if (!args.path || args.name === undefined || !actionType) {
    throw Error('path, name and eventName must be present to track an event');
  }
  var eventParam = Object.assign({}, args, {
    actionType: actionType
  });
  if (userData) {
    eventParam = Object.assign({}, eventParam, userData);
  }
  var data = {
    category: actionType + ":" + eventParam.name,
    label: buildString({
      email: eventParam.email,
      value: eventParam.value,
      sessionId: sessionId
    })
  };
  var type = buildString({
    path: eventParam.path,
    category: actionType + ":" + eventParam.name
  }, '-');
  log(type, data);
  sendEvent(type, data);
};
export var forwardParams = function forwardParams(urlToForward) {
  var urlParams = new URLSearchParams(window.location.search);
  var urlToForwardParams = new URLSearchParams();
  for (var _iterator = _createForOfIteratorHelperLoose(urlParams.entries()), _step; !(_step = _iterator()).done;) {
    var _step$value = _step.value,
      key = _step$value[0],
      value = _step$value[1];
    urlToForwardParams.set(key, value);
  }
  if (UTM_SOURCE && !urlToForwardParams.get('utm_source')) {
    urlToForwardParams.set('utm_source', UTM_SOURCE);
  }
  var utmFromCache = getWithExpiry(UTM_SOURCE_CACHE_KEY);
  if (!UTM_SOURCE && !urlToForwardParams.get('utm_source') && utmFromCache) {
    urlToForwardParams.set('utm_source', utmFromCache);
  }
  var paramsString = urlToForwardParams.toString();
  return "" + urlToForward + (paramsString ? '/?' + paramsString : '');
};

/**
 * @deprecated Please use the new GTM data layer object {@link ./analytics}
 */
export var track = {
  event: event,
  registeredUser: registeredUser,
  unregisteredUser: unregisteredUser,
  sessionFinish: sessionFinish,
  sessionStarted: sessionStarted
};
export default initializeAnalytics;